import type { ILinkType } from "./../models/ILinkType";
import { LexmeaApiClient } from "./apiClient";

export class LinkClient extends LexmeaApiClient {
  fetchLinkTypes = (): Promise<ILinkType[]> => {
    return this.get<ILinkType[]>("api/linkType");
  };
}
